import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { isType } from '@sorare/core/src/lib/gql';

import { RevealPackCardsDialog } from '#src/components/commonCard/RevealPackCardsDialog/index.tsx';

import type { RevealPackCardsDialogFromReward_anyRewardInterface } from './__generated__/index.graphql.ts';

type Props = {
  open: boolean;
  onClose: () => void;
  reward: Nullable<RevealPackCardsDialogFromReward_anyRewardInterface>;
};
export const RevealPackCardsDialogFromReward = ({
  open,
  onClose,
  reward,
}: Props) => {
  if (!isType(reward, 'CardPackReward') || !reward?.pack?.id) {
    return null;
  }
  const packPictureUrl = isType(reward?.config, 'CardPacksRewardConfig')
    ? reward?.config?.cardPack?.pictureUrl || ''
    : '';

  return (
    <RevealPackCardsDialog
      onClose={onClose}
      onContinue={onClose}
      open={open}
      cards={reward?.pack?.cards || []}
      packPictureUrl={packPictureUrl}
      primaryColor="#9464FF"
      secondaryColor="#2A0F49"
      showPlayerDetails
      packId={reward?.pack?.id}
      cardSetSlug={reward?.pack?.cardPack?.cardSet?.slug || ''}
    />
  );
};

RevealPackCardsDialogFromReward.fragments = {
  anyRewardInterface: gql`
    fragment RevealPackCardsDialogFromReward_anyRewardInterface on AnyRewardInterface {
      id
      ... on CardPackReward {
        id
        pack {
          id
          cardPack {
            slug
            cardSet {
              slug
            }
          }
          cards {
            slug
            ...RevealPackCardsDialog_anyCardInterface
          }
        }
        config {
          id
          ... on CardPacksRewardConfig {
            id
            cardPack {
              slug
              pictureUrl
            }
          }
        }
      }
    }
    ${RevealPackCardsDialog.fragments.anyCardInterface}
  ` as TypedDocumentNode<RevealPackCardsDialogFromReward_anyRewardInterface>,
};
